import { ActionTypes } from "../actions/actionTypes";
import { IAuthenticationState } from "../../models/applicationState";
import { AnyAction } from "../actions/actionCreators";
export const reducer = (state: IAuthenticationState[] = [], action: AnyAction) => {
    switch (action.type) {
        case ActionTypes.LOGGED_IN_USER:
            return action.payload;
        case ActionTypes.LOGGED_OUT_USER:
            return null;
        default:
            return state;
    }
};
